export default __webpack_public_path__ + "static/media/no-image2.5116d193.jpg";